import React,{useEffect} from "react";
import { Route } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode"; // Importa correctamente desde "jwt-decode"
import { useHistory } from "react-router-dom";
import { logout } from "../redux/auth/Action";
const PublicRoute = ({ component: Component, ...rest }) => {
  const currentUser = useSelector((state) => state.authReducer);
  const history = useHistory();
  //console.log("currentUser", currentUser);
  const dispatch = useDispatch();

  // Verificar la expiración del token cuando el componente se monta
  if (currentUser && currentUser.token) {
    const decodedToken = jwtDecode(currentUser.token);
    const expirationTime = decodedToken.exp * 1000; // Convertir a milisegundos
    const currentTime = new Date().getTime();
    const timeRemaining = expirationTime - currentTime;
    //console.log("timeRemaining", timeRemaining / 1000);
    // Establecer si el token es válido o no
    if (timeRemaining < 0) {
      dispatch(logout());
    }
  }
  useEffect(() => {
    if (currentUser.is_clave_provisional === true && (currentUser.perfilId == 1 || currentUser.perfilId == 2)) {
      history.push(`/usuarios/change-password/${currentUser.userId}`);
    }else if(currentUser.is_clave_provisional === true && currentUser.perfilId == 3){
      history.push(`/change-password/${currentUser.userId}`);
    }
  }, [currentUser, dispatch, history]);

  return (
    <Route
      {...rest}
      render={(props) => {
        return <Component {...props} />;
      }}
    />
  );
};

export default PublicRoute;
